
import React from 'react';
import { Button } from "@/components/ui/button";
import { 
  Dialog, 
  DialogContent, 
  DialogHeader, 
  DialogTitle, 
  DialogFooter 
} from "@/components/ui/dialog";
import { Doctor } from '@/types';
import { toast } from '@/components/ui/sonner';

interface DeleteConfirmationDialogProps {
  isOpen: boolean;
  doctor: Doctor | null;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteConfirmationDialog: React.FC<DeleteConfirmationDialogProps> = ({
  isOpen,
  doctor,
  onClose,
  onConfirm
}) => {
  const [isDeleting, setIsDeleting] = React.useState(false);
  
  const handleConfirm = async () => {
    if (!doctor) return;
    
    setIsDeleting(true);
    try {
      await onConfirm();
      toast.success(`Dr. ${doctor.name} deleted successfully`);
    } catch (error) {
      console.error('Error deleting doctor:', error);
      toast.error('Failed to delete doctor', {
        description: 'Please try again later'
      });
    } finally {
      setIsDeleting(false);
      onClose();
    }
  };

  if (!doctor) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete Doctor</DialogTitle>
        </DialogHeader>
        <div className="py-4">
          <p className="text-sm text-gray-700">
            Are you sure you want to delete Dr. {doctor.name}? This action cannot be undone.
          </p>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={isDeleting}>Cancel</Button>
          <Button 
            variant="destructive" 
            onClick={handleConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? 'Deleting...' : 'Delete'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;
